import { shallowRef } from 'vue';

const productSelectorList = shallowRef(null);

function registerDeveloperProductSelector(psList) {
    productSelectorList.value = psList;

    return () => {
        if (productSelectorList.value === psList) {
            productSelectorList.value = null;
        }
    }
}

function useDeveloperConsoleState() {
    return { productSelectorList }
}

export { registerDeveloperProductSelector as r, useDeveloperConsoleState as u };
